import React from 'react'
import cx from 'classnames'
import { Draggable } from 'react-beautiful-dnd'
import Image from './Image'

import '../stylesheets/components/Card.scss'

class Card extends React.Component {
    render() {
        return (
            <Draggable
                draggableId={'drag' + this.props.card.id}
                key={'drag' + this.props.card.id}
                index={this.props.index}>
                {(provided) => (
                    <div
                        className={cx('Card', {
                            visible: this.props.card.visible,
                            caption: this.props.caption,
                        })}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}>
                        <div className="Card_container">
                            <div className="Card_image">
                                <Image id={this.props.card.id} />
                            </div>
                            <div className="Card_caption">
                                <p>{this.props.card.title}</p>
                            </div>
                        </div>
                    </div>
                )}
            </Draggable>
        )
    }
}

export default Card
